import { render, staticRenderFns } from "./customer-stat.vue?vue&type=template&id=b83be602&scoped=true"
import script from "./customer-stat.vue?vue&type=script&lang=js"
export * from "./customer-stat.vue?vue&type=script&lang=js"
import style0 from "./customer-stat.vue?vue&type=style&index=0&id=b83be602&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83be602",
  null
  
)

export default component.exports